import { store } from 'redux/store';

interface IContactSupportOptions {
  /** Sentry event id, so support can reference the exact error. */
  eventId?: string;
}

// Opens a pre-filled support email with session details.
export const openSupportEmail = ({ eventId }: IContactSupportOptions = {}): void => {
  const userEmail = store.getState().authSlice.user?.email ?? 'N/A';
  const subject = encodeURIComponent('Ankar Support Request');
  const body = encodeURIComponent(
    [
      'Please describe your issue:',
      '',
      '',
      '--- Session Details ---',
      `User: ${userEmail}`,
      `URL: ${window.location.href}`,
      `Timestamp: ${new Date().toISOString()}`,
      ...(eventId ? [`Error Reference: ${eventId}`] : []),
      `User Agent: ${navigator.userAgent}`,
    ].join('\n'),
  );
  window.open(`mailto:support@ankar.ai?subject=${subject}&body=${body}`, '_self');
};
